import axios from 'axios';
import { API_URL } from 'configs'

export const WORKSPACE_CATEGORIES_REQUEST = 'WORKSPACE_CATEGORIES_REQUEST'
export const WORKSPACE_CATEGORIES_SUCCESS = 'WORKSPACE_CATEGORIES_SUCCESS'
export const WORKSPACE_CATEGORIES_VALIDATION_ERROR = 'WORKSPACE_CATEGORIES_VALIDATION_ERROR'
 const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_WORKSPACE_CATEGORIES_FIELD_VALIDATION_ERROR = "HIDE_WORKSPACE_CATEGORIES_FIELD_VALIDATION_ERROR"
export const REDIRECT_TO_WORKSPACE_CATEGORIES_LIST = 'REDIRECT_TO_WORKSPACE_CATEGORIES_LIST'
export const ACTIVITY_ACCESS_ROLE_SUCCESS = 'ACTIVITY_ACCESS_ROLE_SUCCESS'
export const WORKSPACE_CATEGORIES_GET_SUCCESS = 'WORKSPACE_CATEGORIES_GET_SUCCESS'
export const WORKSPACE_CATEGORIES_SERVER_SUCCESS = 'WORKSPACE_CATEGORIES_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const workspaceCategories = () => ({
  type: WORKSPACE_CATEGORIES_REQUEST,
})

export const workspaceCategoriesServerListCategories = () => ({
  type: WORKSPACE_CATEGORIES_SERVER_SUCCESS,
})

const workspaceCategoriesListSuccess = (workspaceCategoriesList ,workspaceFormValues) => ({
  type: WORKSPACE_CATEGORIES_SUCCESS,
  workspaceCategoriesList: workspaceCategoriesList,
  workspaceFormValues :workspaceFormValues
})



const workspaceCategoriesFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: WORKSPACE_CATEGORIES_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const workspaceCategoriesAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(workspaceCategoriesSuccessNotification(message))
  dispatch(redirectToWorkspaceCategoriesList())
}

export const redirectToWorkspaceCategoriesList = () => ({
  type: REDIRECT_TO_WORKSPACE_CATEGORIES_LIST,
})

const getWorkspaceCategoriesSuccess = (response, action) => ({
  type: WORKSPACE_CATEGORIES_GET_SUCCESS,
  record: response,
  actionType: action
})

const workspaceCategoriesSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})

export const hideWorkspaceCategoriesValidationError = (feild_key) => ({
  type: HIDE_WORKSPACE_CATEGORIES_FIELD_VALIDATION_ERROR,
  feild_key: feild_key
})


export const getWorkspaceFormValues = (names) => {
  var token = localStorage.getItem("token");
  return dispatch => {
    dispatch(workspaceCategories());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace_categories/getFormValues", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        names: names,
      }
    })
      .then((response) => {
        dispatch(workspaceCategoriesListSuccess(response.data));
        dispatch(hideCommonLoader());
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      });
  }
}

export const workspaceCategoriesListFetch = () => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceCategories())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_categories/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
    })
      .then((response) => {
        dispatch(workspaceCategoriesListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}




export const addWorkspaceCategories = (name, opt_display,object_viewed_id ='') => {
console.log('objectid',object_viewed_id)
  var token = localStorage.getItem("token");
  let cat_name = name.replace(/_/g, " ").replace(/ /g, "-");
  return dispatch => {
    dispatch(workspaceCategories());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspace_categories/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        name: name,
        opt_display: opt_display,
        object_viewed_id:object_viewed_id
      }
    })
      .then((response) => {
        workspaceCategoriesAddUpdateSuccess(cat_name+' Added Successfully', 'create', dispatch);

        let lista = [
          "industry",
          "account_managers_client",
          "account_managers_premier",
          "sub_industry",
          "nature_of_clients_customer",
          "signup_year",
          "client_does",
          "relevant_operations_resource",
          "services_we_offer",
        ];
        dispatch(getWorkspaceFormValues(lista));
        
        
        dispatch(hideCommonLoader());
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      });
  }
}


export const updateWorkspaceCategories = (data) => {
  var token = localStorage.getItem("token");
  //let cat_name = str.replace(/_/g, " ").replace(/ /g, "-");
  return dispatch => {
    dispatch(workspaceCategories())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_categories/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer '+ token
      },
      data: data
    })
      .then((response) => {
        workspaceCategoriesAddUpdateSuccess(' Updated Successfully', 'update', dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const getWorkspaceCategoriesById = (workspace_id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceCategories())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_categories/getById/" + workspace_id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer '+ token
      },
    })
      .then((response) => {
        dispatch(getWorkspaceCategoriesSuccess(response.data, action))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const deleteWorkspaceCategories = (workspace_id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  //let cat_name = str.replace(/_/g, " ").replace(/ /g, "-");
  return dispatch => {
    dispatch(workspaceCategories())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_categories/delete/" + workspace_id, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(workspaceCategoriesSuccessNotification(' deleted successfully'))
        dispatch(workspaceCategoriesListFetch())
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(workspaceCategoriesFailure(err))
    }
  }
  catch (e) {
    dispatch(workspaceCategoriesFailure('Unable to perform action.Something went wrong'))
  }
}   